export const API_URL = process.env.REACT_APP_API_URL;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const NFT_URL = process.env.REACT_APP_NFT_URL;
export const NFT_HASH = process.env.REACT_APP_NFT_HASH;
export const EXDEX_API_URL = process.env.REACT_APP_EXDEX_API_URL
export const TENX_IMAGE_URL= process.env.REACT_APP_TENX_IMAGE_URL